/**
 * Role definitions and access control configuration.
 * Add new roles here and define their allowed tabs/features.
 */

export const ROLES = {
    ADMIN: "admin",
    SUB_ADMIN: "sub-admin",
};

/**
 * Defines which sidebar tabs each role can access.
 * admin  → full access
 * sub-admin → limited (no settings)
 */
export const ROLE_ACCESS = {
    [ROLES.ADMIN]: {
        tabs: ["dashboard", "users", "settings"],
        canDownload: true,
        canViewDetails: true,
    },
    [ROLES.SUB_ADMIN]: {
        tabs: ["dashboard", "users"],
        canDownload: false,
        canViewDetails: false,
    },
};

/**
 * Returns the access config for a given role.
 * Falls back to sub-admin (most restrictive) if role is unknown.
 */
export const getAccessByRole = (role) => {
    // console.log("[Roles] Resolving access for role:", role);
    const access = ROLE_ACCESS[role] || ROLE_ACCESS[ROLES.SUB_ADMIN];
    // console.log("[Roles] Access config resolved:", access);
    return access;
};
